import { Component } from '@angular/core';

/**
 * Skeleton component for product details summary card
 * @export
 * @class AtmSkeletonProductDetailCardSummaryComponent
 */
@Component({
  selector: 'atm-skeleton-product-detail-summary-card',
  templateUrl: './atm-skeleton-product-detail-summary-card.component.html',
  styleUrls: ['./atm-skeleton-product-detail-summary-card.component.scss']
})
export class AtmSkeletonProductDetailCardSummaryComponent {

}
